/*
* @requires  ../util/websocket.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {

    function SealWebsocket(param,m,callback) {
        this.host="ws://127.0.0.1:18211/seal";
        this.context=param.context;
        this.websocket=$m.createWebSocketWrapper(param,this.host);
        this.setEventCallback(m,callback)
        this.websocket.connect(param);
    }

    SealWebsocket.prototype.setEventCallback=function(m,callback){
        this.middlewareObj=m;
        this.websocket.setEventCallback(m,callback);
    };

    SealWebsocket.prototype.setContext=function (param) {
        var name="setContext";
        var that=this;

        var p={};
        $m.util.setAttrs(p,param,["contextType","config"]);

        this.websocket.sendMessage({
            fun: 'SetContext',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.getContext=function (param) {
        var name="getContext";
        var that=this;

        var p={};
        $m.util.setAttrs(p,param,["context"]);

        this.websocket.sendMessage({
            fun: 'GetContext',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.config);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.getContexts=function (param) {
        var name="getContexts";
        var that=this;

        var p={};

        this.websocket.sendMessage({
            fun: 'GetContexts',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.contexts);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.listSeal=function (param) {
        var name="listSeal";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["certSn"]);

        this.websocket.sendMessage({
            fun: 'ListSeal',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.seals);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.getSealB64=function (param) {
        var name="getSealB64";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["sealSn","certId","ca"]);

        this.websocket.sendMessage({
            fun: 'GetSealB64',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.seal);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.getSealInfo=function (param) {
        var name="getSealInfo";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["sealSn","seal","certId","ca"]);

        this.websocket.sendMessage({
            fun: 'GetSealInfo',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.sealInfo);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.selectSeal=function(param){
        var name="selectSeal";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["certSn"]);

        this.websocket.sendMessage({
            fun: 'SelectSeal',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.seal);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.signSealSignature=function (param) {
        var name="signSealSignature";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["data","sealSn","certId","ca","dataFormat","charset","password",
            "certVerify","sealVerify","enableTimeStamp"]);

        this.websocket.sendMessage({
            fun: 'SignSealSignature',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.sealSignature);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.signSealSignatureBatch=function (param) {
        var name="signSealSignatureBatch";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["data","sealSn","certId","ca","dataFormat","charset","password",
            "enableThreads","certVerify","sealVerify","enableTimeStamp"]);

        this.websocket.sendMessage({
            fun: 'SignSealSignatureBatch',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.sealSignatures);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.verifySealSignature=function (param) {
        var name="verifySealSignature";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["data","dataFormat","charset","sealSignature","certVerify","sealVerify","hash"]);

        this.websocket.sendMessage({
            fun: 'VerifySealSignature',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.verifySealSignatureBatch=function (param) {
        var name="verifySealSignatureBatch";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["data","dataFormat","charset","sealSignature","certVerify","sealVerify","hash"]);

        this.websocket.sendMessage({
            fun: 'VerifySealSignatureBatch',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.result);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.getSealSignatureInfo=function (param) {
        var name="getSealSignatureInfo";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["sealSignature"]);

        this.websocket.sendMessage({
            fun: 'GetSealSignatureInfo',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.sealSignatureInfo);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.signSeal=function (param) {
        var name="signSeal";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["data","sealSn","certId","ca","dataFormat","charset","password","enableTimeStamp","timeStampHasCert",
            "certVerify","sealVerify"]);

        this.websocket.sendMessage({
            fun: 'SignSeal',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.signData);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.signSealBatch=function (param) {
        var name="signSealBatch";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["data","sealSn","certId","ca","dataFormat","charset","password","enableTimeStamp","timeStampHasCert",
            "enableThreads","certVerify","sealVerify"]);

        this.websocket.sendMessage({
            fun: 'SignSealBatch',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.signDatas);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.verifySignSeal=function (param) {
        var name="verifySignSeal";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["data","dataFormat","charset","cert","signature","seal","timeStamp", "signTime","certVerify","sealVerify"]);

        this.websocket.sendMessage({
            fun: 'VerifySignSeal',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.verifySignSealBatch=function (param) {
        var name="verifySignSealBatch";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["dataFormat","charset","signSealData","certVerify","sealVerify"]);

        this.websocket.sendMessage({
            fun: 'VerifySignSealBatch',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.result);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.loginSeal=function (param) {
        var name="loginSeal";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["sealSn","password","certId","ca"]);

        this.websocket.sendMessage({
            fun: 'LoginSeal',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.writeSeals=function (param) {
        var name="writeSeals";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["certSn","seals","password"]);

        this.websocket.sendMessage({
            fun: 'WriteSeals',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.deleteSeals=function (param) {
        var name="deleteSeals";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["certSn","sealSns","password"]);

        this.websocket.sendMessage({
            fun: 'DeleteSeals',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.verifyCert=function (param) {
        var name="verifyCert";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["cert","time","certVerify"]);

        this.websocket.sendMessage({
            fun: 'VerifyCert',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.verifySeal=function (param) {
        var name="verifySeal";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["seal","sealSn","cert","time","certVerify","sealVerify"]);

        this.websocket.sendMessage({
            fun: 'VerifySeal',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.signSealHash=function (param) {
        var name="signSealHash";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["hash","sealSn","certId","ca","password","enableTimeStamp",
            "certVerify","sealVerify","docProperty","signatureFormat"]);

        this.websocket.sendMessage({
            fun: 'SignSealHash',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.sealSignature);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.oesGetSealImageById=function (param) {
        var name="oesGetSealImageById";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["plugin","sealId"]);

        this.websocket.sendMessage({
            fun: 'OesGetSealImageById',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.imageInfo);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.oesGetProviderInfo=function (param) {
        var name="oesGetProviderInfo";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["plugin"]);

        this.websocket.sendMessage({
            fun: 'OesGetProviderInfo',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.providerInfo);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.getPluginInfo=function (param) {
        var name="getPluginInfo";
        var that=this;

        var p={
            context: this.context,
        };

        this.websocket.sendMessage({
            fun: 'GetPluginInfo',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.infoes);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.handSign=function (param) {
        var name="handSign";
        var that=this;

        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["data","certSn","dataFormat","charset","password",
            "zoomSize","handSignType",
            "deviceFilter","certCnFilter",
            "certVerify","enableTimeStamp"]);

        this.websocket.sendMessage({
            fun: 'HandSign',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.sealSignature);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    SealWebsocket.prototype.close=function () {
        this.websocket.close()
    };

    $m.SealWebsocket=SealWebsocket;
})(HebcaMiddleware);
